module.exports = __webpack_public_path__ + "static/media/292x0w (4).4de09edc.webp";